import React, {useEffect, useState} from 'react';
import './signup.css'
import {useHistory, Link, useLocation} from 'react-router-dom';
import logo from '../../images/SuperSeva_Logo_white.png'

import axios  from 'axios';
const SignUp=()=>{
    const history=useHistory()
    const location = useLocation()
    const [data, setdata]=useState(
        {
            name:'', 
            email:'',
            phone:'',                           
            corporate_name:'',               
            password:'',
            pre_request_Data:location.state
        })
        const [scheme, setscheme]=useState([]);
let [err, seterr]=useState({})

const SignUp=()=>{  
    axios.post('/signup',data).then((res)=>{  
        if(res.data==='This email is already registered'){
            alert(res.data)
        }else{
            alert('Thanks For Registration Please Login')
            history.replace('/login')
            history.go(0)
        }
        // console.log(res.data)
    })
}

    const handlesubmit=(ev)=>{
        ev.preventDefault()
        let err={};
        if(!data.name.trim()){
            err.name='Please Enter Name'
        }
        if(!data.email.trim()){
            err.email='Please Enter email'
        }
        if(!data.phone.trim()){
            err.phone='Please Enter phone'
        }
        if(!data.corporate_name.trim()){
            err.corporate_name='Please Select corporate name'
        }
        if(!data.password.trim()){
            err.password='Please Enter password'
        }
        seterr({...err})
        if(Object.keys(err).length===0){
            SignUp()
        }
    }
    const getScheme=()=>{
        axios.get('/get_schemes_stamp_paper')
        .then(res=>{
            console.log(res,'respo')
            if(res.data){
                setscheme(res.data.data)
            }
        })
    }
    useEffect(()=>{
        getScheme()
    }, [])
    return(
    <div className="wrapper fadeInDown">
    <div id="formContent">

        <div className="fadeIn" style={{
            display:'flex',justifyContent:'center', alignItems:'center',
            padding:10
        }}>
            <img src={logo} id="icon" alt="User Icon" />
        </div>
        <div style={{paddingLeft:10, paddingRight:10}}>
            <form action='/signup' onSubmit={handlesubmit}>
                <div>
                    <label>Name</label>
                    <input type="text" value={data.name}
                    onChange={(ev)=>{
                        setdata({...data, name:ev.target.value})
                        seterr({...err, name:''})

                    }} id="name" className="fadeIn second" name="name" placeholder="Enter your Name"/>
                    {err.name&&
                        <span style={{color:'red'}}>{err.name}</span>
                    }
                </div>
                <div>
                    <label>Email</label>
                    <input type="text" id="email"
                    value={data.email}
                    onChange={(ev)=>{
                        setdata({...data, email:ev.target.value})
                        seterr({...err, email:''})

                    }} className="fadeIn second" name="email" placeholder="Email / Phone Number"/>
                    {err.email&&
                        <span style={{color:'red'}}>{err.email}</span>
                    }
                </div>
                <div>
                    <label>Contact Number</label>
                    <input type="text" id="phone" value={data.phone}
                    onChange={(ev)=>{
                        setdata({...data, phone:ev.target.value})
                        seterr({...err, phone:''})

                    }} className="fadeIn second" name="phone" placeholder="Phone Number"/>
                    {err.phone&&
                        <span style={{color:'red'}}>{err.phone}</span>
                    }
                </div>
                <div>
                    <label>Corporate Name</label>
                    {/*
                        <input type="text" id="corporate" value={data.corporate_name}
                        onChange={(ev)=>{
                            setdata({...data, corporate_name:ev.target.value})
                            seterr({...err, corporate_name:''})
    
                        }} className="fadeIn third" name="corporate_name" placeholder="Corporate Name"/>
                    */}
                    <div>
                        <select onChange={(ev)=>{
                            setdata({...data, corporate_name:ev.target.value})
                            seterr({...err, corporate_name:''})
                        }} className='form-select' name="corporate_name" id="corporate_name">
                            <option key='-1' value="">Select</option>
                            {scheme.map((scemedata, i)=>{
                                return(
                                    <option key={i} value={scemedata.scheme_name}>{scemedata.scheme_name}</option>
                                )
                            })}
                        </select>
                    </div>
                    {err.corporate_name &&
                        <span style={{color:'red'}}>{err.corporate_name}</span>
                    }
                </div>
                <div>
                    <label>Choose Password</label>
                    <input type="text" id="password" value={data.password}
                    onChange={(ev)=>{
                        setdata({...data, password:ev.target.value})
                        seterr({...err, password:''})

                    }} className="fadeIn third" name="password" placeholder="Chhose Password"/>
                    {err.password&&
                        <span style={{color:'red'}}>{err.password}</span>
                    }
                </div>
                <div>
                    <span style={{
                        fontSize:12
                    }}>By proceeding, I agree to the Terms Of Service and Privacy Policy.</span>
                </div>
                <div>
                    <input type="submit"  className="fadeIn fourth" value="SignUp"/>
                </div>
                </form>
        </div>

        <div id="formFooter">
            <div>
                <a className="underlineHover" href="#">Forgot Password?</a>
            </div>
            <div>
                <Link className="underlineHover" to="/login">Login?</Link>
            </div>
        </div>

    </div>
    </div>
    )
}
export default SignUp;